// extracted by mini-css-extract-plugin
export default {"container":"ClaimFilter_container__RIgKa","listContainer":"ClaimFilter_listContainer__UhHuN"};